export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '排气压力(MPa)',
    en: 'Exhaust Pressure(MPa)',
    dataIndex: 'exhaustPressure',
    key: 'exhaustPressure'
  },
  {
    zh: '排气温度(℃)',
    en: 'Exhaust Temperature(℃)',
    dataIndex: 'exhaustTemperature',
    key: 'exhaustTemperature'
  },
  {
    zh: '变频温度(℃)',
    en: 'Inverter Temperature(℃)',
    dataIndex: 'inverterTemperature',
    key: 'inverterTemperature'
  },
  {
    zh: '输出电流(A)',
    en: 'Output Current',
    dataIndex: 'outputCurrent',
    key: 'outputCurrent'
  },
  {
    zh: '变频温度报警值',
    en: 'Inverter Temperature Value',
    dataIndex: 'inverterTemperatureValue',
    key: 'inverterTemperatureValue'
  },
  {
    zh: '占比',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage'
  }
]